import { analytics, ChatEventName, EventCategory } from '../index';
// track how much time each recipients are taking to respond againt the last receieved message dateCreated
export var timeTakenToReply = function (sender, recepients, messages, userType, channelSid) {
    var _loop_1 = function (recepient) {
        var otherMemMessages = messages.filter(function (message) { return message.authorIdentity === recepient.identity; });
        var unReadMessages = otherMemMessages.filter(function (otherMemMessage) { var _a; return otherMemMessage.index > ((_a = sender === null || sender === void 0 ? void 0 : sender.lastConsumedMessageIndex) !== null && _a !== void 0 ? _a : 0); });
        if (unReadMessages.length > 0) {
            var worstCaseTimestamp = unReadMessages.sort(function (one, two) {
                return one.dateCreated.getTime() - two.dateCreated.getTime();
            })[0].dateCreated;
            var diff = Date.now() - Number(worstCaseTimestamp);
            // The Time Difference between (when the other member sends the message) and (when I read the message)
            var minutes = diff / (1000 * 60);
            var timeToRead = "".concat(minutes);
            var event_1 = {
                time_to_read: timeToRead,
                category: EventCategory.CHAT,
                event_name: ChatEventName.MESSAGE_READ,
                channel_sid: channelSid,
                user_type: userType,
            };
            analytics(event_1);
        }
    };
    for (var _i = 0, recepients_1 = recepients; _i < recepients_1.length; _i++) {
        var recepient = recepients_1[_i];
        _loop_1(recepient);
    }
};
//# sourceMappingURL=index.js.map